import React from 'react'
import { Provider } from 'react-redux'
import { UserContextProvider } from '../../shared/context/userContext'

import store from '../libs/store'
import App from './app'
import { UnreadProvider } from './contexts/unread'
import { MessagesProvider } from './contexts/all'

const Main = (props) => {
  if (!props.current_user) return <div>You must be logged in to use messenger.</div>

  return (
    <Provider store={store}>
      <UnreadProvider>
        <MessagesProvider>
          <UserContextProvider current_user={props.current_user}>
            <App />
          </UserContextProvider>
        </MessagesProvider>
      </UnreadProvider>
    </Provider>
  )
}

export default Main